export default "__VITE_ASSET__Cne0Yj25__"